import { useMemo } from "react";
import axios from "axios";
import { API } from "@/lib/api";

const KEY = "ondose_staff_token";
export const staffToken = { get: () => localStorage.getItem(KEY), set: (t) => localStorage.setItem(KEY, t), clear: () => localStorage.removeItem(KEY) };

export function useStaffApi() {
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use((c) => {
      const t = staffToken.get();
      if (t) c.headers.Authorization = `Bearer ${t}`;
      return c;
    });
    return inst;
  }, []);
}
